module.exports = __webpack_public_path__ + "static/media/PK.e5c80180.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PK.svg
// module id = 2239
// module chunks = 7